<template>
  <div class="page">
    <el-tabs class="tabsdiv" type="border-card">
      <el-tab-pane class="gaojiandiv" label="稿件详情">
        <manuscript-details></manuscript-details>
      </el-tab-pane>
      <el-tab-pane label="稿件留言区">
        <comment-reply></comment-reply>
      </el-tab-pane>
      <el-tab-pane label="用稿协议">
        <draft-agreement></draft-agreement>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import ManuscriptDetails from '@/components/ManuscriptDetails/ManuscriptDetails'//稿件详情区
  import CommentReply from '@/components/CommentReply/CommentReply'//评论留言区
  import DraftAgreement from '@/components/DraftAgreement/DraftAgreement'//稿件协议
  export default {
    components: {
      "comment-reply": CommentReply,
      "manuscript-details": ManuscriptDetails,
      "draft-agreement": DraftAgreement
    },
    data() {
      return {
      }
    },
    //初始化方法
    mounted() {
      // var cookie = this.baseUrl.getCookie("userInfo");
      // if (cookie == ""){
      //   this.$router.push({
      //     path: '/layoutnologin',
      //     query: {
      //       manuscriptId: this.$route.query.manuscriptId,
      //     }
      //   })
      // }
    },
    methods: {

    }
  }
</script>
<style scoped>
  /deep/ .el-tabs__item {
    width: 367px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }
  /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom: 1px solid #e0e0e0;
  }
  .gaojiandiv {
    width: 100%;
    /* height: 700px; */
  }
  .tabsdiv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }
  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
    margin: 5px 0px 0px 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/PageInfoLayout.vue